import React from 'react';

export const SelectARoundText = () => {
    return (
        <h2 className="ladder-table-drawer__heading-content-title">
            Select a round
        </h2>
    );
};
